import { render, staticRenderFns } from "./RequestPresentationBtn.vue?vue&type=template&id=5b4062f5&scoped=true&"
import script from "./RequestPresentationBtn.vue?vue&type=script&lang=js&"
export * from "./RequestPresentationBtn.vue?vue&type=script&lang=js&"
import style0 from "./RequestPresentationBtn.vue?vue&type=style&index=0&id=5b4062f5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b4062f5",
  null
  
)

export default component.exports